import { render, staticRenderFns } from "./shimmer-preview.vue?vue&type=template&id=3b870584&scoped=true&"
import script from "./shimmer-preview.vue?vue&type=script&lang=js&"
export * from "./shimmer-preview.vue?vue&type=script&lang=js&"
import style0 from "./shimmer-preview.vue?vue&type=style&index=0&id=3b870584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b870584",
  null
  
)

export default component.exports